/* ==========================================================================
   Elevate Floors — Página de serviço: seletor de aparência

   O JS aqui faz o mínimo: liga e desliga a classe .is-on e escreve DUAS custom
   properties com a cor do painel. A transição de cor e o crossfade das fotos
   ficam no CSS.

   Nenhuma troca de src: as fotos são renderizadas todas e empilhadas. Trocar o
   src mostraria um frame vazio enquanto a próxima baixa, e é justamente no
   primeiro clique que ela ainda não está em cache.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section._efPickBound) return;
    section._efPickBound = true;

    var chips  = Array.prototype.slice.call(section.querySelectorAll('[data-go]'));
    var shots  = Array.prototype.slice.call(section.querySelectorAll('[data-shot]'));
    var slides = Array.prototype.slice.call(section.querySelectorAll("[data-opt]"));
    var panel  = section.querySelector('[data-panel]');
    if (!chips.length || !panel) return;

    function show(i) {
      chips.forEach(function (c, k) {
        c.classList.toggle('is-on', k === i);
        c.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      shots.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });

      var active = slides[i];
      if (!active) return;
      if (active.dataset.bg) panel.style.setProperty('--ef-pick-bg', active.dataset.bg);
      if (active.dataset.fg) panel.style.setProperty('--ef-pick-fg', active.dataset.fg);
    }

    chips.forEach(function (c, k) {
      c.addEventListener('click', function () { show(k); });
    });

    // nunca deixar nenhum selecionado: o painel ficaria vazio
    show(0);
  }

  function init() {
    document.querySelectorAll('[data-pick]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
